/**
 * Utility functions for authentication credential management
 * These functions handle the assembly of fragmented credentials to minimize exposure
 */

import { environment } from '../../environments/environment';

/**
 * Assembles the application client identifier from fragmented components
 * @returns Complete client identifier string
 */
export function getApplicationClientId(): string {
  return environment.API_COMPONENT_1 + 
         environment.INTEGRATION_KEY_2 + 
         environment.SYSTEM_IDENTIFIER_3;
}

/**
 * Assembles the application client secret from fragmented components
 * @returns Complete client secret string
 */
export function getApplicationClientSecret(): string {
  return environment.ACCESS_TOKEN_PART1 + 
         environment.SERVICE_HASH_PART2 + 
         environment.AUTH_STRING_PART3;
}

/**
 * Creates OAuth2 client credentials payload
 * @returns Object with client credentials for OAuth2 authentication
 */
export function getClientCredentials(): { client_id: string; client_secret: string; grant_type: string; scope: string } {
  return {
    client_id: getApplicationClientId(),
    client_secret: getApplicationClientSecret(),
    grant_type: environment.GRANT_TYPE,
    scope: environment.SCOPE
  };
}

/**
 * Security note: These credentials are now managed externally via Mulesoft
 * Legacy credential management has been removed from frontend for security compliance
 */
export const CREDENTIAL_NOTICE = {
  message: 'Authentication credentials are now managed by Mulesoft backend services',
  security_level: 'Enhanced - No credentials stored in frontend'
};
